var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueadd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.01 6.66585C9.58334 6.66585 9.15667 6.50335 8.83167 6.17835L7.17501 4.52169C6.52501 3.87169 6.52501 2.81419 7.17501 2.16419L8.83167 0.50752C9.48084 -0.14248 10.5392 -0.14248 11.1883 0.50752L12.845 2.16419C13.495 2.81419 13.495 3.87169 12.845 4.52169L11.1883 6.17835C10.8633 6.50335 10.4367 6.66585 10.01 6.66585ZM8.09084 10.4584C7.25167 9.68002 5.87417 9.83502 5.24751 10.8734C4.84084 11.5484 4.95584 12.4192 5.45167 13.0309L6.94167 14.9509C7.22417 15.3142 7.15834 15.8375 6.79417 16.12C6.43084 16.4025 5.90751 16.3367 5.62501 15.9725L4.13501 14.0525C3.20001 12.9 3.06417 11.265 3.82001 10.0125C3.92251 9.84252 4.04167 9.68669 4.16751 9.53919V4.67002C4.16751 3.58002 3.38334 2.58752 2.29917 2.47835C1.05251 2.35335 0.000839233 3.32919 0.000839233 4.55085V13.34C0.000839233 15.1184 0.711673 16.8234 1.97501 18.0759L3.46834 19.555C3.77667 19.8409 4.18084 19.9992 4.60167 19.9992H10.8342C11.2942 19.9992 11.6675 19.6259 11.6675 19.1659V15.9825C11.6675 14.6034 11.0975 13.285 10.0925 12.34L8.09084 10.4584ZM17.7017 2.47919C16.6175 2.58752 15.8333 3.58085 15.8333 4.67085V9.54085C15.9592 9.68835 16.0775 9.84335 16.1808 10.0142C16.9358 11.2667 16.8008 12.9017 15.8658 14.0542L13.3342 16.5742V19.1675C13.3342 19.4609 13.2742 19.7392 13.1808 20.0009H15.4008C15.8208 20.0009 16.2258 19.8425 16.5342 19.5567L18.0258 18.08C19.29 16.8284 20.0017 15.1225 20.0017 13.3425V4.55169C20.0017 3.33002 18.9508 2.35419 17.7033 2.47919H17.7017ZM14.7533 10.8742C14.1267 9.83585 12.7492 9.68085 11.91 10.4592L11.2167 11.1109L11.2333 11.1267C12.1842 12.0209 12.8342 13.18 13.1358 14.4334L14.5483 13.0317C15.0442 12.42 15.1592 11.5484 14.7525 10.8742H14.7533Z",
    fill: "url(#paint0_linear_188_253)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_253",
    x1: 10.0013,
    y1: 0.0200195,
    x2: 10.0013,
    y2: 20.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueadd);
export default __webpack_public_path__ + "static/media/valueadd.08dd2f9e9a5deabfaa19f00d5c18e5ec.svg";
export { ForwardRef as ReactComponent };